import React, { useEffect } from 'react';

import ImageCarousel from './components/ImagesCarousel';
import MobileCockpit from './MobileCockpit';
import * as S from './styles';
import { RefreshTokenDebug } from 'components/RefreshTokenDebug';
import { useTab } from 'global/TabContext';
import { useMenuTitle } from 'hooks/useMenuTitleContext';
import Agenda from 'pages/Cockpit/components/Agenda';
import { useEvents } from 'pages/Cockpit/components/Agenda/hooks/useEvents';
import { useIsMobile, useIsTablet } from 'utils/mediaQueries';

interface CockpitProps {
  isAgenda: boolean;
}

export const Cockpit: React.FC<CockpitProps> = ({ isAgenda = false }) => {
  const { eventsToday } = useEvents();
  const [activeTab] = React.useState('tab_cockpit');
  const { setActiveTabContext } = useTab();
  const { updateMenuTitle } = useMenuTitle();

  useEffect(() => {
    setActiveTabContext(activeTab);
  }, [activeTab, setActiveTabContext, updateMenuTitle]);

  const isMobile = useIsMobile();
  const isTablet = useIsTablet();

  return isMobile || isTablet ? (
    <S.MobileSection>
      <MobileCockpit events={eventsToday} />
    </S.MobileSection>
  ) : (
    <S.Wrapper>
      <S.Container>
        <S.Content>
          {!isAgenda && (
            <>
              <S.Section>
                <ImageCarousel />
              </S.Section>
            </>
          )}
          <S.Section>
            <Agenda />
          </S.Section>
        </S.Content>
      </S.Container>
      <RefreshTokenDebug show={false} />
    </S.Wrapper>
  );
};
